// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2ScI0","footer":"ModalUpdate_footer__11VPj"};